import { useContext } from "react";

import { useTranslation } from "react-i18next";

import NoResultsFoundIcon from "assets/customIcons/emptyTable/NoResultsFoundIcon";
import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import ParamsContext from "context/params/paramsContext";
import TableContext from "context/table/tableContext";

import { useSharedContainerStyle } from "./hooks";

const NoResultsFound = () => {
    const { resetAllParams } = useContext(ParamsContext);

    const { isInnerTable, noResultsReason, resetInnerTableAllParams } =
        useContext(TableContext);

    const { t } = useTranslation();
    const sharedStyle = useSharedContainerStyle();

    return (
        <div css={sharedStyle}>
            <NoResultsFoundIcon />

            <div>
                <div>{t("Table##empty table##no results found##title")}</div>

                <div>
                    {noResultsReason ||
                        t("Table##empty table##no results found##description")}
                </div>
            </div>

            <Button
                color={BUTTON_COLORS.Primary}
                size={BUTTON_SIZES.Small}
                variant={BUTTON_VARIANTS.TextOnly}
                onClick={
                    isInnerTable ? resetInnerTableAllParams : resetAllParams
                }
            >
                {t("Table##empty table##button##reset view")}
            </Button>
        </div>
    );
};

export default NoResultsFound;
